import { render } from "./MaterialPaginationItem.vue?vue&type=template&id=d8baed3c"
import script from "./MaterialPaginationItem.vue?vue&type=script&lang=js"
export * from "./MaterialPaginationItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrew/Work/Projects/Pocketkey/qrdynamic/qrdynamic-admin/qrdynamic-admin-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__